var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagedAzureDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_64",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#bbb",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_azure_blob_table-disabled",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002---Source-_-Target---Drag-_-Drop_",
    "data-name": "002---Source-&-Target---Drag-&-Drop_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2, -2)",
    filter: "url(#Ellipse_64)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64-2",
    "data-name": "Ellipse 64",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(2 2)",
    fill: "#fbfbfb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-2",
    "data-name": "Page-1",
    transform: "translate(12.667 12.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.986,6.986H0V0H6.986Z",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M183.986,6.986H177V0h6.986V6.986Z",
    transform: "translate(-169.32)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M6.986,183.986H0V177H6.986Z",
    transform: "translate(0 -169.32)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M183.986,183.986H177V177h6.986v6.986Z",
    transform: "translate(-169.32 -169.32)",
    fill: "#c8c8c8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedAzureDisabled);
export default __webpack_public_path__ + "static/media/managed-azure-disabled.c4ee25e0883c85a953640f43f0ef3261.svg";
export { ForwardRef as ReactComponent };